import { Box, Pagination, Button, Typography, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';

import { getTheme } from 'app/components/ThemeProvider/theme';
import { useChangeWorkersStatus } from 'app/utils/services/salaryServices';
import Loader from 'app/components/Loader';
import { WorkersResponse } from 'app/utils/services/types/salary.type';

import AmountModal from './AmountModal';
import EmployeesTable from './EmployeesTable';
import { WorkersCheck } from './EmployeesTable/EmployeesTable';

import { pagination } from './SalaryPage.sx';
interface Props {
  page: number;
  handlePageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  workers: WorkersResponse;
  workersLoading: boolean;
  refetchWorkers: () => void;
  fetchingWorkers: boolean;
  refetchSalaryData: () => void;
  handleNewPaymentPage: () => void;
}

const EmployeeList = ({
  workers,
  workersLoading,
  page,
  handlePageChange,
  refetchWorkers,
  fetchingWorkers,
  refetchSalaryData,
  handleNewPaymentPage,
}: Props) => {
  const [amountModal, setAmountModal] = useState(false);
  const theme = getTheme('light');
  const changeWordersStatus = useChangeWorkersStatus();
  const [selectedWorkers, setSelectedWorkers] = useState<WorkersCheck[]>([]);
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const handleChildData = (data: WorkersCheck[]) => {
    setSelectedWorkers(data);
  };

  const changeWorkersStatusToUnList = () => {
    changeWordersStatus.mutate(
      {
        id_list: selectedWorkers.map((worker) => worker.id),
        action: 'unlist',
      },
      {
        onSuccess: () => {
          refetchWorkers();
        },
      }
    );
  };

  return (
    <>
      {!workersLoading && !fetchingWorkers && (
        <EmployeesTable refetchWorkers={refetchWorkers} workers={workers?.workers} handleChildData={handleChildData} />
      )}
      {(workersLoading || fetchingWorkers) && <Loader />}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '24px',
        }}
      >
        {workers?.total_pages > 1 && (
          <Pagination
            sx={pagination}
            siblingCount={smallScreen ? -1 : 1}
            count={workers?.total_pages}
            page={page}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
          />
        )}
        <Box sx={{ display: 'flex', gap: '12px', marginLeft: 'auto' }}>
          <Button
            size={'large'}
            color={'warning'}
            disabled={!selectedWorkers?.length}
            onClick={changeWorkersStatusToUnList}
          >
            <Typography sx={{ color: 'white' }}>Siyahıdan çıxart</Typography>
          </Button>
          <Button
            disabled={!selectedWorkers?.length}
            size={'large'}
            color={'info'}
            variant={'contained'}
            onClick={() => setAmountModal(true)}
          >
            Davam et
          </Button>
        </Box>
      </Box>
      <AmountModal
        open={amountModal}
        close={setAmountModal}
        selectedWorkers={selectedWorkers}
        refetchSalaryData={refetchSalaryData}
        handleNewPaymentPage={handleNewPaymentPage}
      />
    </>
  );
};

export default EmployeeList;
